import styled from "@emotion/styled";

export const AuthenticatorContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px;
  align-items: flex-start;
  @media (max-width: 1000px) {
    width: 100%;
  }
`;
